export default __webpack_public_path__ + "static/media/Red0000.1af480a3.png";